// extracted by mini-css-extract-plugin
export var product_content = "styles-module--product_content--aaf1f";
export var product_content__left = "styles-module--product_content__left--5c868";
export var product_tag = "styles-module--product_tag--2d62a";
export var product_wrapper = "styles-module--product_wrapper--c6e7f";